import { onCLS, onFID, onLCP } from 'web-vitals';

function sendToAnalytics() {
  // Replace with whatever serialization method you prefer.
  // Note: JSON.stringify will likely include more data than you need.
  // const body = JSON.stringify(metric, null, 2);
  // console.log(body);
  // Use `navigator.sendBeacon()` if available, falling back to `fetch()`.
  // (navigator.sendBeacon && navigator.sendBeacon('/analytics', body)) ||
  //   fetch('/analytics', {body, method: 'POST', keepalive: true});
}

export const reportWebVitals = () => {
  // 実行可能となった時点ですぐに LCP の測定やログ記録を実行します。
  onCLS(sendToAnalytics);
  onFID(sendToAnalytics);
  onLCP(sendToAnalytics);
};
